<template>
  <div class="foot">
    <p class="mzsm">本站中的网页作品模板尽可供个人网页学习、网页制作参考使用。您在本站获取的一切资源请勿商业使用。</p>
    <div class="flex">
      <p>联系Q V:1292179368</p>
    <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2024093245号-1</a>
    </div>
    </div>
</template>

<script>
export default {
    name: 'footerIndex',  // 修改为多词的组件名称
}
</script>

<style>
.foot {
  background-color: #854685;
  font-size: 2.6vw; /* 字体大小使用vw */
  padding: 3vw 5vw;
  color: #fff;
}
.flex{
    display: flex;
  justify-content: center;
  align-items: center;
  gap: 4vw;
  margin-top: 2vw;
}
.foot a {
  color: #fff;
}
.mzsm{
  line-height: 4vw;
}

</style>